export default "__VITE_ASSET__tVaEfP9Y__"